import React, {useState} from 'react';

type InputProps = {
    label: string,
    name: string,
    id: string,
    placeholder: string,
    autoComplete: string
    required: boolean,
    onChange: any,
    refObj: any
}

const eyeSvg = (isShown: boolean = false) => {
    const slash = isShown ? "</>" : <path d="M2 2L22 22" stroke="#000000" stroke-width="2" stroke-linecap="round"
                                          stroke-linejoin="round"/>

    return <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
        {slash}
        <path
            d="M6.71277 6.7226C3.66479 8.79527 2 12 2 12C2 12 5.63636 19 12 19C14.0503 19 15.8174 18.2734 17.2711 17.2884M11 5.05822C11.3254 5.02013 11.6588 5 12 5C18.3636 5 22 12 22 12C22 12 21.3082 13.3317 20 14.8335"
            stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path
            d="M14 14.2362C13.4692 14.7112 12.7684 15.0001 12 15.0001C10.3431 15.0001 9 13.657 9 12.0001C9 11.1764 9.33193 10.4303 9.86932 9.88818"
            stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
};


export const PasswordInput = ({
                                  label,
                                  name,
                                  id,
                                  placeholder,
                                  autoComplete,
                                  required,
                                  onChange,
                                  refObj
                              }: InputProps) => {

    const [showPassword, setShowPassword] = useState(false);


    return <aside>
        <div className="relative w-full">
            <div className="absolute inset-y-0 right-0 flex items-center px-2">
                <label htmlFor={id} className="sr-only">{label}</label>
                <label onClick={() => setShowPassword(!showPassword)}
                       className="bg-gray-200 hover:bg-gray-300 rounded px-2 py-1 text-sm text-gray-600 font-mono cursor-pointer js-password-label"
                       htmlFor="toggle">
                    {eyeSvg(showPassword)}
                </label>
            </div>
            <input
                ref={refObj} id={id} name={name} type={showPassword ? "text" : "password"} autoComplete={autoComplete} required={required}
                className="w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                placeholder={placeholder} onChange={(e) => onChange(e.target.value)}
            />
        </div>
    </aside>;
}